import React from "react";
import {cx} from "../../lib/ClassSet";
import {List} from "immutable";
import {Link} from "react-router";
import "./DeliveryItem.css";
import {formatFulfillmentStatus} from "../../lib/FulfillmentStatus";
import format from 'date-fns/format'
import {ComplimentaryTag, ReplacementTag, GiftTag, SalesTag} from "../../components/MiniTag";

const completedStates = List(["delivered", "partially_delivered"])

const DeliveryItem = (props) => {

  let {data} = props;

  const isGift = data.get("gift") === true;
  const isSales = data.get("salesOrderId", "").length === 32;
  const isComplimentary = data.get("type") === "complimentary";
  const isReplacement = data.get("type") === "replacement";

  let classes = cx({
    "item": true,
    "delivery-list-item": true,
    "u-warning": data.get("pickupOverdue") || data.get("hold"),
    "u-cancelled": data.get("fulfillmentStatus") === "cancelled",
    "u-completed": completedStates.includes(data.get("fulfillmentStatus")),
    "u-sales": isSales,
    "u-complimentary": isComplimentary,
    "u-replacement": isReplacement,
    "u-gift": isGift,
  })

  let status = data.get("fulfillmentStatus");
  if (data.get("scheduled") && status === "ready") {
    status = "scheduled";
  }
  if (data.get("hold") === true) {
    status = "hold";
  }

  let pickupDate = "Not Scheduled";
  if (data.get("scheduled")) {
    pickupDate = format(data.get("pickupDate"), "MMM D, YYYY");
  }

  return (
    <tr className={classes}>
      <td className="field f-id"><Link to={`/shipping/orders/${data.get("orderId")}`}>{data.get("orderId")}</Link></td>
      <td className="field">{pickupDate}</td>
      <td className="field f-x"><GiftTag show={isGift} /></td>
      <td className="field">{data.getIn(["deliveryAddress", "name"])}</td>
      <td className="field">{data.get("nrPackages")}</td>
      <td className="field f-fulfillment"><span className="icon" /><span className="text">{formatFulfillmentStatus(status)}</span></td>
      <td className="field f-x">
        <SalesTag show={isSales} />
        <ComplimentaryTag show={isComplimentary} />
        <ReplacementTag show={isReplacement} />
        <GiftTag show={isGift} />
      </td>
    </tr>
  )
}

export default DeliveryItem;